<script setup>
import { useI18n } from 'vue-i18n';
import SalesListRefreshStatus from './SalesListRefreshStatus.vue';

const props = defineProps({
  activeList: { type: String, required: true },
  listTabs: { type: Array, required: true },
  loading: { type: Boolean, default: false },
  updatedAt: { type: [Date, String, Number], default: null },
});

const emit = defineEmits(['refresh', 'selectList']);
const { t } = useI18n();
</script>

<template>
  <header
    data-testid="sales-index-header"
    class="flex w-full flex-col border-b border-[#E0E7EB] bg-white font-roboto font-bold shadow-[0_2px_4px_rgba(0,0,0,0.08),0_0_6px_rgba(0,0,0,0.02)]"
  >
    <div
      class="flex min-h-[52px] items-center justify-between gap-4 px-[18px] py-0.5"
    >
      <div class="flex items-center gap-[5px] text-xl text-[#464F53]">
        <span
          class="i-heroicons-building-office-2-solid size-5 text-[#01988C]"
          aria-hidden="true"
        />
        <span>{{ t('SALES.TITLE') }}</span>
      </div>
      <SalesListRefreshStatus
        :loading="loading"
        :updated-at="updatedAt"
        @refresh="emit('refresh')"
      />
    </div>

    <div
      role="tablist"
      :aria-label="t('SALES.ARIA.LISTS')"
      class="flex h-[60px] items-stretch gap-2 overflow-x-auto px-[18px] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
    >
      <button
        v-for="item in props.listTabs"
        :key="item.id"
        type="button"
        role="tab"
        class="inline-flex shrink-0 items-center gap-1.5 rounded-t-[10px] border-b-2 px-3 text-sm font-bold capitalize transition hover:bg-[#EDF8F7]"
        :class="
          props.activeList === item.id
            ? 'border-[#01988C] text-[#01988C]'
            : 'border-transparent text-[#464F53]'
        "
        :aria-selected="props.activeList === item.id ? 'true' : 'false'"
        @click="emit('selectList', item.id)"
      >
        <span
          v-if="item.id === 'arquivados'"
          class="i-heroicons-trash-solid size-4 text-[#01988C]"
          aria-hidden="true"
        />
        <span>{{ item.label }}</span>
        <span v-if="Number(item.badge) > 0" class="font-normal">
          {{ `(${item.badge})` }}
        </span>
      </button>
    </div>
  </header>
</template>
